import { RouteConfig } from 'vue-router/types/router';

export default [{ path: '/', redirect: '/pipelines' }] as Array<RouteConfig>;
